import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CoreApiService } from '../../core-api.service';
import { LoggingService } from '../../logging.service';
import { NotificationService } from '../../notification.service';
import { DataView, DataViewPayload } from '../../shared/models/data-view.model';

@Component({
  styleUrls: ['./data-view-promote-dialog.component.scss'],
  templateUrl: './data-view-promote-dialog.component.html',
})
export class DataViewPromoteDialogComponent {
  public form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataView,
    private coreApi: CoreApiService,
    private logger: LoggingService,
    private notifications: NotificationService,
    public dialogRef: MatDialogRef<DataViewPromoteDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      label: new FormControl(this.data.label, [Validators.required]),
      description: new FormControl(this.data.description),
    });
  }

  onPromote(): void {
    const data = this.form.getRawValue();
    for (const key of Object.keys(this.data)) {
      if (!['_id', 'created', 'modified', 'parent', 'origin', 'label', 'description'].includes(key)) {
        data[key] = this.data[key];
      }
    }
    this.coreApi.views.promote(data as DataViewPayload)
      .subscribe({
        next: () => this.notifications.success('views.promote.success'),
        error: error => {
          this.notifications.error('views.promote.error');
          this.logger.error(error);
        },
      });
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
